import { create } from 'zustand';
import { TUsersStore } from './types';
import { userSlice } from './user.slice';
import { usersSlice } from './users.slice';
import { invitesSlice } from './invites.slice';
import { manualNotesSlice } from './manualNotes.slice';

export const useUsersStore = create<TUsersStore>((...arg) => ({
  ...userSlice(...arg),
  ...usersSlice(...arg),
  ...invitesSlice(...arg),
  ...manualNotesSlice(...arg),
}));

export * from './types';
